/**
 * Created by mark on 6/24/2019.
 */
import Service from "../../../Services/index"

const ChequeListPayoff = {
    namespaced: true,
    state: {
        ChequeList: [],
        form: {
            payoff_id: "",
            customer_id: "",
            sale_id: "",
            amount: "",
            transaction_id: "",
            ref_no: "",
            cheque_date: "",
            status: "",
            bankbook: "",
            bank: "",
            bank_id: "",
            approve_date: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            sale_id: "",
            customer_id: "",
            date: [],
            status: "",
            cheque_p: [],
            ref_no: '',
            amount: '',
        }

    },
    mutations: {
        GET_CHEQUE_LIST: (state, res) => {
            state.ChequeList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_CHEQUE_LIST_BY_ID: (state, res) => {
            state.form = res;
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                sale_id: "",
                customer_id: "",
                date: [],
                status: "",
                cheque_p: [],
            }
        }
    },
    actions: {
        setChequeListPayoff({commit}, {page = 1, sale_id}) {
            return Service.ChequeListPayoff.getChequeListPayoff(page, sale_id).then(res => {
                commit("GET_CHEQUE_LIST", res);
            });
        },
        saveChequeListPayoff({commit}, {id, data}) {
            if (!id) {
                return Service.ChequeListPayoff.createChequeListPayoff(data).then(res => {
                    //console.log("create");
                });
            } else {
                return Service.ChequeListPayoff.updateChequeListPayoff(id, data).then(res => {
                    //console.log("update");
                });
            }
        },
        showChequeListPayoff({commit}, id) {
            return Service.ChequeListPayoff.showChequeListPayoff(id).then(res => {
                commit("GET_CHEQUE_LIST_BY_ID", res);
            })
        },
        search({commit}, {page, data}) {
            return Service.ChequeListPayoff.searchChequeListPayoff(page, data).then(res => {
                commit("GET_CHEQUE_LIST", res)
            })
        },
        selectAll({commit}, data) {
            return Service.ChequeListPayoff.selectAllChequeListPayoff(data);
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        updateChequeStatus({commit}, data) {
            return Service.ChequeListPayoff.updateChequeStatus(data);
        },
        deleteChequeListPayoff({commit}, id) {
            return Service.ChequeListPayoff.deleteChequeListPayoff(id);
        }
    }
};

export default ChequeListPayoff
